import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./card.css";
import { useDispatch, useSelector } from "react-redux";
import { removeSelectedIntruments, selectSavedInstruments } from "../../../../slices/SavedInstrumentSlice";
import ViewSavedInstrumentsHeader from "../../modals/viewSavedInstrumentsModal/ViewSavedInstrumentsHeader";
import OrComponent from "../../../resuableComponents/orUIComponent/OrComponent";
import CardPaymentForm from "./cardPaymentForm";
import { Typography } from "antd";
import "../../modals/viewSavedInstrumentsModal/viewSavedInstruments.css";
import { methodSelectedEvent, addNewSavedCardEvent, saveCardBackButtonClickedEvent, viewAllSavedCardsEvent } from "../../../../Utils/uiAnalytics";
import { generateDynamicLogo } from "../../../../Utils/utils";
import TranslateText from "../../../resuableComponents/TranslateText";
import BottomSheet from "../../../resuableComponents/BottomSheet/BottomSheet";
import PaymentIntrumentSelection from "../paymentInstrumentSelection/PaymentIntrumentSelection";
import { selectDarkColor, selectBaseColor } from "../../../../slices/PaymentSessionDetailsSlice";
import { selectIsMobileLayout } from "../../../../slices/MobileLayoutSlice";
import { selectActivePaymentMethod } from "../../../../slices/PaymentButtonSlice";

export default function CardPaymentOption({ cardMethodInfo }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [componentRender, setComponentRender] = useState(false);
  const savedInstruments = useSelector((state) => selectSavedInstruments(state));
  const darkColor = useSelector((state) => selectDarkColor(state));
  const [cardInstruments, setCardInstruments] = useState([]);
  const [isAddNewCard, setIsAddNewCard] = useState(false);
  const [openSavedCardsSheet, setOpenSavedCardsSheet] = useState(false);
  const baseColor = useSelector((state) => selectBaseColor(state));
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const activePaymentMethod = useSelector(selectActivePaymentMethod);
  const issuers = useSelector((state) => state.paymentInstrumentIssuers.issuers);

  useEffect(() => {
    setComponentRender(true);
  }, []);
  useEffect(() => {
    if (componentRender) {
      // methodSelectedEvent("Card", "");
    }
  }, [componentRender]);
  useEffect(() => {
    if (savedInstruments) {
      let cardMethod = savedInstruments
        ?.filter((instrumentInfo) => instrumentInfo?.type === "Card")
        ?.map((instrumentInfo) => {
          const issuerCode =
            typeof instrumentInfo?.issuer === "string"
              ? instrumentInfo.issuer
              : instrumentInfo?.issuer?.name;
          if (!issuerCode) return instrumentInfo;
          const issuerTitle = issuers.find((i) => i?.code === issuerCode)?.title;
          return issuerTitle ? { ...instrumentInfo, issuers: issuerTitle } : instrumentInfo;
        });
      setCardInstruments(cardMethod);
    }
  }, [savedInstruments, issuers]);
  let cardMethod = cardMethodInfo?.find(
    (cardInfo) => cardInfo.type === "Card"
  );

  const handleAddNewCardClick = () => {
    addNewSavedCardEvent();
    setIsAddNewCard(true);
    dispatch(removeSelectedIntruments());
  }

  // On mobile only the first 2 saved cards are inline; the rest open in a bottom sheet.
  const showMobileViewAll = isMobileLayout && cardInstruments?.length > 2;

  const handleViewAllClick = () => {
    viewAllSavedCardsEvent();
    dispatch(removeSelectedIntruments());
    setOpenSavedCardsSheet(true);
  };

  const handleCloseSavedCardsSheet = () => {
    dispatch(removeSelectedIntruments());
    setOpenSavedCardsSheet(false);
  };

  const handleBackButtonClick = () => {
    saveCardBackButtonClickedEvent();
    setIsAddNewCard(false)
  }

  useEffect(() => {
    if (activePaymentMethod !== "Card") {
      setIsAddNewCard(false)
    }
  }, [activePaymentMethod]);

  const addNewCardTile = (
    <div className="add-new-card-tile" onClick={handleAddNewCardClick}>
      <div className="add-new-card-tile-icon" style={{ color: baseColor }}>+</div>
      <div className="add-new-card-tile-info">
        <Typography className="add-new-card-tile-title dynamic-font-family" style={{ color: baseColor }}>
          <TranslateText label={"ADD_NEW_CARD"}>Add New Card</TranslateText>
        </Typography>
        <Typography className="add-new-card-tile-sub dynamic-font-family">
          <TranslateText label={"ADD_NEW_CARD_SUBTITLE"}>Visa, Mastercard, Rupay & more</TranslateText>
        </Typography>
      </div>
    </div>
  );

  return (
    <div className="deliveryForm">
      {
        !isLoggedIn ? (
          <CardPaymentForm />
        ) : (
          !isAddNewCard ? (
            <>
              {
                cardInstruments?.length > 0 && (
                  <ViewSavedInstrumentsHeader
                    data={cardInstruments}
                    title={isMobileLayout ? '' : t("SAVED_CARDS")}
                    type={"Card"}
                    showPayButton={false}
                    afterList={!isMobileLayout ? addNewCardTile : null}
                  />
                )
              }
              {
                cardInstruments?.length > 0 ? (
                  <>
                    {showMobileViewAll && (
                      <BottomSheet
                        title={t("SAVED_CARDS")}
                        type={"pay"}
                        open={openSavedCardsSheet}
                        handleClose={handleCloseSavedCardsSheet}
                        children={<PaymentIntrumentSelection data={cardInstruments} />}
                      />
                    )}
                    {showMobileViewAll && (
                      <div className="saved-cards-view-all-row">
                        <div
                          className="domestic-saved-instruments-view-all-logo dynamic-font-family"
                          onClick={handleViewAllClick}
                        >
                          <Typography className="domestic-saved-instruments-view-all-title dynamic-title">
                            <TranslateText label={"VIEW_ALL"}>View All</TranslateText>
                          </Typography>
                          {generateDynamicLogo("rightArraow", "14px", "14px", baseColor)}
                        </div>
                      </div>
                    )}
                    {/* On web the Pay button sits inside the list, so the tile is rendered there (above it). */}
                    {isMobileLayout && addNewCardTile}
                  </>
                ) : (
                  <CardPaymentForm />
                )
              }
            </>
          ) : (
            <div>
              {
                isLoggedIn && (
                  <div className="backButtonBox" onClick={handleBackButtonClick}>
                    {generateDynamicLogo(
                      "leftArrow",
                      "20px",
                      "20px",
                      "",
                      '#000'
                    )}
                    <TranslateText label={"ADD_NEW_CARD"}>Add New Card</TranslateText>
                  </div>
                )
              }
              <CardPaymentForm />
            </div>
          )
        )
      }


      {/* {cardMethod && cardInstruments?.length > 0 && <OrComponent />} */}
    </div>
  );
}
